<template>
  <div style="width: 100%">
    <v-dialog v-model="message.status" width="500">
      <v-card>
        <v-toolbar dense flat dark :color="message.color">
          <span v-if="message.color==='error'" style="color: white !important;">
          خطا
            </span>
          <span v-else style="color: white !important;">
          عملیات موفق
            </span>
        </v-toolbar>

        <v-row class="ma-1">
          <v-col cols="12">
            {{ message.text }}
          </v-col>
          <v-col cols="12" md="12" class="text-left">
            <v-btn color="error" outlined dark @click="message.status=false"> بستن </v-btn>
          </v-col>

        </v-row>
      </v-card>
    </v-dialog>

    <delete-confirmation
      :delete-confirmation-dialog-status="deleteConfirmationDialog"
      :widgets="widgets"
      :delete-record-data="deleteRecordData"
      @response_handler="responseHandler"
      @initial-delete-confirmation-with-nothing="initialDeleteConfirmationWithNothing"
    />
    <v-row class="ma-0">
      <template v-for="widget in widgets">
        <custom-component
          v-if="widget.type==='custom'"
          :widget="widget"
          @response_handler="responseHandler"
          @close-dialog="cancel"
        />
        <v-col
          :cols="widget.size.small"
          :sm="widget.size.small"
          :md="widget.size.medium"
          :lg="widget.size.larg"
          :xl="widget.size.xlarg"
          :offset-xl="widget.size.xlOffset"
          :offset-lg="widget.size.lgOffset"
          :offset-sm="widget.size.smOffset"
          :offset-md="widget.size.mdOffset"
          :class="widget.className"
          style="position: relative"
        >
          <b style="position: absolute;
top: -12px;
z-index: 1;
background-color: white;
right: 43px;" class="pa-3 float-right" v-if="widget.title!==''">{{widget.title}}</b>
          <n-dialog :state="widget.data.model" :widgets="widget.data.widget" :title="widget.data.title"
                    v-if="widget.type==='dialog'" :id="widget.data.name" :editOrShowTarget="editOrShowTarget"
                    :paramId="paramId" :requestApiUrl="requestApiUrl" @close-dialog="closeDialog"
                    :width="widget.data.width"/>
          <n-tab-group :state="widget.data.model" :widgets="widget.data" :title="widget.data.title"
                    v-if="widget.type==='tabGroup'" :id="widget.data.name" :editOrShowTarget="editOrShowTarget"  @filter-page="filterPage"
                    :paramId="paramId" :requestApiUrl="requestApiUrl" @on-pagination="onPagination" style="margin-top: -17px !important;"/>
          <v-card outlined v-if="widget.type==='productList'">
            <product-grid1 :widget="widget" v-if="widget.type==='productList'" :filter="filter"
                           @on-pagination="onPagination"   @response_handler="responseHandler" @open-dialog="openDialog"/>
          </v-card>

          <info-card :widget="widget" v-if="widget.type==='info'"/>
          <tile-default-design :widget="widget" v-if="widget.type==='tile' && widget.data.template==='defaultDesign'"/>
          <tile-default-design-dens :widget="widget" v-if="widget.type==='tile' && widget.data.template==='defaultDesignDens'"/>
          <tile-btn-design :widget="widget" v-if="widget.type==='tile' && widget.data.template==='btnDesign'"/>
          <kpi-tile :widget="widget" v-if="widget.type==='kpiTile'"/>
          <multiple-kpi-tile :widget="widget" v-if="widget.type==='multipleKpiTile'"/>
          <tile-icon-left-default-design :widget="widget"
                                         v-if="widget.type==='tile' && widget.data.template==='defaultIconLeftDesign'"
                                         @open-dialog="openDialog"/>

          <ticket-activities v-if="widget.type==='ticket'" :widget="widget"/>
          <full-dynamic-html v-if="widget.type==='htmlContent' || widget.type==='hook'" :widget="widget"/>
          <v-card outlined class="pa-2" v-if="widget.type==='table'">
            <full-dynamic-table
              v-if="widget.type==='table'"
              :widget="widget"
              :widgets="widgets"
              :edit-or-show-target="editOrShowTarget"
              :filter="filter"
              @show-delete-confirmation-dialog="showDeleteConfirmationDialog"
              @response_handler="responseHandler"
              @filter-page="filterPage"
              @on-pagination="onPagination"
              @open-dialog="openDialog"
              :filterModelForTableExcel="filterModelForTableExcel"
            />
          </v-card>
          <v-card outlined :class="'pa-2 ' + widget.className" v-if="widget.type==='form'">
            <full-dynamic-form
              ref="childForm"
              v-if="widget.type==='form'"
              :widget="widget"
              :widgets="widgets"
              :param-id="paramId"
              :filter="filter"
              :request-api-url="requestApiUrl"
              @response_handler="responseHandler"
              @filter-page="filterPage"
              @open-dialog="openDialog"
              @close-dialog-nested="closeDialogNested"
              @push-excel-data="pushExcelData"
            />
          </v-card>
          <v-card outlined class="pa-2"
                  v-if="widget.type==='chart' && (widget.data.template==='bar' || widget.data.template==='line' || widget.data.template==='area')">
            <bar-line-area-chart
              v-if="widget.type==='chart' && (widget.data.template==='bar' || widget.data.template==='line' || widget.data.template==='area')"
              :height="widget.data.height"
              :template="widget.data.template"
              :vertical-axis-series="widget.data.verticalAxisSeries"
              :horizontal-axis="widget.data.horizontalOrLabelAxis"
              :request-action="widget.data.requestAction"
              :request-time="widget.data.requestTime"
            />
          </v-card>
          <v-card class="pa-2" outlined
                  v-if="widget.type==='chart' && (widget.data.template==='polarArea' || widget.data.template==='pie' || widget.data.template==='donut')">
            <polar-area-pie-donut-chart
              v-if="widget.type==='chart' && (widget.data.template==='polarArea' || widget.data.template==='pie' || widget.data.template==='donut')"
              :height="widget.data.height"
              :template="widget.data.template"
              :vertical-axis-series="widget.data.verticalAxisSeries"
              :horizontal-axis="widget.data.horizontalOrLabelAxis"
            />
          </v-card>
          <v-card outlined class="pa-2" v-if="widget.type==='chart' && widget.data.template==='candlestick'">
            <candle-chart
              v-if="widget.type==='chart' && widget.data.template==='candlestick'"
              :height="widget.data.height"
              :template="widget.data.template"
              :vertical-axis-series="widget.data.verticalAxisSeries"
              :horizontal-axis="widget.data.horizontalOrLabelAxis"
            />
          </v-card>

          <group v-if="widget.type==='group'" :widgets="widget.data.widget" :id="widget.data.name"
                 :editOrShowTarget="editOrShowTarget"
                 :paramId="paramId" :requestApiUrl="requestApiUrl" @on-pagination-nested="onPaginationNested"/>

        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>


import {
  mdiCheckCircleOutline,
  mdiEyeOutline,
  mdiMenuLeftOutline, mdiMenuRightOutline,
  mdiMinusCircleOutline,
  mdiPen,
  mdiTrashCan,
  mdiInformationOutline
} from '@mdi/js'
import axios from '@axios'
import store from "@/store";
import moment from 'jalali-moment'
import baseConfig from '@/../baseConfig'

import DeleteConfirmation from "@/views/generator/dialogs/delete-confirmation";
import FullDynamicTable from "@/views/generator/tables/full-dynamic-table";
import FullDynamicForm from "@/views/generator/forms/full-dynamic-form";
import FullDynamicHtml from "@/views/generator/htmlContents/full-dynamic-html";
import TicketActivities from "@/views/generator/tickets/ticket-activities";
import TileDefaultDesign from "@/views/generator/vueContents/tile/tile-default-design";
import TileIconLeftDefaultDesign from "@/views/generator/vueContents/tile/tile-icon-left-default-design";
import InfoCard from "@/views/generator/vueContents/info/info-card";
import KpiTile from "@/views/generator/vueContents/tile/kpi-tile";
import ProductTemplate1 from "@/views/generator/product/product-template1";
import ProductGrid1 from "@/views/generator/product/product-grid1";
import NDialog from "@/views/generator/dialogs/n-dialog";
import {convertDateToPersian} from "@/views/generator/page-handler";
import BarLineAreaChart from "@/views/generator/charts/bar-line-area-chart";
import PolarAreaPieDonutChart from "@/views/generator/charts/polarArea-pie-donut-chart";
import CandleChart from "@/views/generator/charts/candle-chart";
import Group from "@/views/generator/group/group";
import CustomComponent from "@/views/customComponent";
import NTabGroup from "@/views/generator/tabGroup/n-tab-group";
import TileBtnDesign from "@/views/generator/vueContents/tile/tile-btn-design";
import MultipleKpiTile from "@/views/generator/vueContents/tile/multiple-kpi-tile";
import TileDefaultDesignDens from "@/views/generator/vueContents/tile/tile-default-design-dens";
import themeConfig from "@themeConfig";


export default {
  name: 'PageRender',
  components: {
    TileDefaultDesignDens,
    MultipleKpiTile,
    TileBtnDesign,
    NTabGroup,
    CustomComponent,
    Group,
    CandleChart,
    PolarAreaPieDonutChart,
    BarLineAreaChart,
    NDialog,
    ProductGrid1,
    ProductTemplate1,
    KpiTile,
    InfoCard,
    TileIconLeftDefaultDesign,
    TileDefaultDesign,
    TicketActivities,
    FullDynamicHtml,
    FullDynamicForm,
    FullDynamicTable,
    DeleteConfirmation,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    widgets: Array,
    editOrShowTarget: String,
    paramId: String,
    requestApiUrl: String,
  },
  mounted() {
    this.$store.dispatch("setting/setSetting")
    if (store.state.message.message !== null) {
      this.responseHandler(store.state.message.message)
      store.dispatch("message/resetMessage")
    }
  },
  data() {
    return {

      deleteRecordData: null,
      filterModelForTableExcel: null,
      deleteConfirmationDialog: false,
      message: {
        status: false,
        text: 'success operation',
        color: 'success',
      },

      filter: {
        id: 0,
        body: null,
        action: null
      },
      mdiCheck: mdiCheckCircleOutline,
      mdiMinus: mdiMinusCircleOutline,
      mdiInformationOutline: mdiInformationOutline,
      editIcon: mdiPen,
      deleteIcon: mdiTrashCan,
      mdiDetails: mdiEyeOutline,
      mdiMenuLeft: mdiMenuLeftOutline,
      mdiMenuRight: mdiMenuRightOutline,
      deleteUrl: '',

      temp: [],
      hiddenElements: []

    }
  },
  methods: {
    getValueByKey(keySearch){
      let setting=this.$store.state.setting.setting
      Object.keys(setting).forEach(function(key, index) {
        if(setting[key].key===keySearch)
          setting = setting[key].value;
      })
      return setting
    },
    responseHandler(r, refresh = false) {
      if (r.data.message !== '') {
        this.message = {
          status: true,
          text: r.data.message,
          color: r.data.status,
        }
      }
      if (refresh) {
        this.$emit('get-page')
      }
      setTimeout(() => {
        this.message.status = false
      }, 30000)
    },

    closeDialog(dialog) {
      console.log(dialog)
      this.widgets.map(w => w.type === 'dialog' ? w.data.name === dialog ? w.data.model = false : null : null)
    },
    closeDialogNested(dialog) {
      this.$emit('n-dialog-send-dialog-id', dialog)
    },
    openDialog(dialog, moveBodyToDialog = null, destinationForm = null, data = []) {

      this.widgets.map(w => w.type === 'dialog' ? w.data.name === dialog ? w.data.model = true : null : null)

      this.widgets.map(w => w.type === 'dialog' ? w.data.name === dialog ? w.data.widget.map(ww => {
        if (ww.type === 'form') {
          if (destinationForm !== null) {
            this.hiddenElements.map(remove => {
              if (destinationForm === remove.formName) {
                remove.elements.map(eh => {
                  ww.data.elements.splice(eh.indexArr, 0, eh)
                })
              }
            })
            this.hiddenElements.map(remove => {
              if (destinationForm === remove.formName) {
                remove.elements = []
              }
            })
            //  this.hiddenElements.map(f => f.formName === destinationForm ? f.elements.map(eh => ww.data.elements.splice(eh.indexArr, 0, eh)) : '')
            //  this.hiddenElements = []
            ww.data.elements.map(e => {
              data.data.data.map(d => {

                if (d.set === e.name) {
                  if (d.with !== '@hide')
                    if (e.type === 'date') {
                      e.model = convertDateToPersian(d.with)
                    } else {
                      let formated = d.with
                      if(e.maskName==='phone') {
                        formated = formated.replace(/^(\d{4})(\d{3})(\d{4}).*/, `$1${e.strMask}$2${e.strMask}$3`)
                      }
                      else if(e.maskName === 'tell') {
                        formated = formated.replace(/^(\d{3})(\d{4})(\d{4}).*/, `$1${e.strMask}$2${e.strMask}$3`)
                      }
                      e.model = formated
                    }
                  else if (ww.data.elements.findIndex(e => e.name === d.set) !== -1) {
                    if (this.hiddenElements.findIndex(f => f.formName === destinationForm) === -1)
                      this.hiddenElements.push({
                        formName: destinationForm,
                        elements: []
                      })

                    e.indexArr = ww.data.elements.findIndex(e => e.name === d.set)

                    this.hiddenElements.map(f => f.formName === destinationForm ? f.elements.push(e) : '')
                  }

                }
              })
            })

            this.hiddenElements.map(remove => {
              this.widgets.map(w => w.type === 'dialog' ? w.data.name === dialog ? w.data.widget.map(ww => {
                if (ww.type === 'form') {
                  if (destinationForm === remove.formName) {
                    remove.elements.map(er => {
                      ww.data.elements.splice(ww.data.elements.findIndex(e => e.name === er.name), 1)
                    })
                  }
                }
              }) : null : null)
              //  ww.data.elements.splice(ww.data.elements.findIndex(e => e.name === d.set), 1)

            })

          }
          if (moveBodyToDialog !== null)
            moveBodyToDialog.map(mbtd => {
              ww.data.elements.push(
                {
                  "name": mbtd.name,
                  "size": {
                    "small": 0,
                    "medium": 0,
                    "larg": 0,
                    "xlarg": 0
                  },
                  "fromRelation": "",
                  "maskName": mbtd.maskName,
                  "strMask": mbtd.strMask,
                  "removedStrMask": mbtd.removedStrMask,
                  "type": "hidden",
                  "label": "",
                  "validations": [],
                  "permissionName": null,
                  "permissionActions": [],
                  "onChange": [],
                  "model": mbtd.model,
                  "rules": []
                }
              )
            })
        }
        if (ww.type === 'htmlContent') {
          if (typeof ww.data.contentsBackup === 'undefined')
            ww.data.contentsBackup = ww.data.contents[0]
          ww.data.contents[0] = ww.data.contentsBackup
          let thisData = ww.data.contents[0]
          if (destinationForm !== null) {
            // eslint-disable-next-line array-callback-return
            data.data.data.map(d => {
              if (d.with !== '@hide') {
                const rep = `@${d.set}`
                thisData = this.replaceAll(thisData, rep, d.with)
              }
            })
          }
          const rep = '@token'
          thisData = this.replaceAll(thisData, rep, localStorage.getItem('accessToken'))
          ww.data.contents = [thisData]
        }
        if (ww.type === 'custom') {
          console.log(ww.data.name === data.data.componentTarget)
          if (ww.data.name === data.data.componentTarget) {
            const result = {[data.data.componentTarget]: data.data}
            this.$store.dispatch('result/setResult', result)
          }
        }
      }) : null : null)
    },
    replaceAll(string, search, replace) {
      return string.split(search).join(replace)
    },
    initialDeleteConfirmationWithNothing() {
      this.deleteRecordData = null
      this.deleteConfirmationDialog = false
    },
    onPagination(name, current) {
      console.log('final ran',name, current)
      this.$emit('on-pagination', name, current, this.filter)
    },
    onPaginationNested(name, current, filter) {
      this.$emit('on-pagination-into-dialog-or-group', name, current, this.filter)
    },
    showDeleteConfirmationDialog(deleteRecordData, deleteConfirmationDialog) {
      this.deleteRecordData = deleteRecordData
      this.deleteConfirmationDialog = deleteConfirmationDialog;
    },
    filterPage(r) {
      console.log("ran filter here pag render")
      if(typeof  r.data!=='undefined')
        this.$emit('filter-page', r.data.data.page)
      else
        this.$emit('filter-page', r)
    },
    cancel() {
      this.$emit('close-dialog')
    },
    pushExcelData(d){
      this.filterModelForTableExcel = d
    }

  },
}
</script>

<style>
.v-application .body-1 {
  font-size: 0.8rem !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 0.7rem !important;
}

.v-card {
  overflow: auto !important;
}

.v-card__subtitle, .v-card__text, .v-card__title {
  padding: 17px 24px !important;
}

.v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
  margin-right: -14px !important;
}

.vpd-weekday {
  color: rgb(58, 40, 149) !important;
}

.vpd-day-text {
  color: rgb(58, 40, 149) !important;
}

.vpd-month-label {
  color: rgb(58, 40, 149) !important;
}
*{
  word-break: unset !important;
}
.v-card .v-card__title {
  line-height: 1.7 !important;
}
.displayNone{
  display: none !important;
}
</style>
